import { RequestAccessActionTypes } from '../../actions/request-access/request-access.actions';
import { AppState } from 'src/app/app.state';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export interface RequestAccessState {
  error?: ApiResponseSimple;
  captcha: boolean;
  loading: boolean;
  loaded: boolean;
}

const initialState: RequestAccessState = {
  error: null,
  captcha: null,
  loading: null,
  loaded: null
};

export function requestAccessReducer(
  state: RequestAccessState = initialState,
  action: any
): RequestAccessState {
  switch (action.type) {
    case RequestAccessActionTypes.CAPTCHA:
      return {
        ...state,
        error: null,
        captcha: true,
        loading: false,
        loaded: false
      };
    case RequestAccessActionTypes.REQUEST:
      return {
        ...state,
        error: null,
        captcha: false,
        loading: true,
        loaded: false
      };
    case RequestAccessActionTypes.REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        captcha: false,
        loading: false,
        loaded: true
      };

    case RequestAccessActionTypes.REQUEST_ERROR:
       return {
        ...state,
        error: action.error,
        captcha: false,
        loading: false,
        loaded: false
      };

    default:
      return state;
  }
}

export const getRequestAccessState = (state: AppState) => state.requestAccess;
export const getRequestAccessCaptcha = (state: RequestAccessState) => state.captcha;
export const getRequestAccessLoading = (state: RequestAccessState) => state.loading;
export const getRequestAccessSuccess = (state: RequestAccessState) => state.loaded;
export const getRequestAccessError = (state: RequestAccessState) => state.error;
